import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

const INSTAGRAM_URL = "https://instagram.com/lenz3.ir";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-[#e6e4df] bg-[#fafaf8]">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-center sm:flex-row sm:text-start md:px-6">
        <p className="text-xs text-[#8b919c]">
          © {year} {t("footer.brand")}
          {t("footer.brandAlias") ? ` (${t("footer.brandAlias")})` : ""} — {t("footer.tagline")}
        </p>
        <Link to="/about" className="text-xs font-semibold text-[#1b4d3e] hover:underline">
          {t("footer.about")}
        </Link>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer me"
          className="inline-flex items-center gap-2 rounded-lg border border-[#e6e4df] bg-white px-3 py-1.5 text-xs font-semibold text-[#1a1c1e] transition-colors hover:border-[#c9c6bf] hover:bg-[#f6f5f2]"
          aria-label={t("footer.instagramAria")}
        >
          <svg
            viewBox="0 0 24 24"
            className="h-4 w-4"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9A5.5 5.5 0 0 1 16.5 22h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2zm0 2A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 16.5 4h-9zm9.25 1.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
          </svg>
          {t("footer.instagram")}
        </a>
      </div>
    </footer>
  );
};

export default Footer;
